import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Button from '@marvelapp/marvel-ui/button';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Heading from '@marvelapp/marvel-ui/heading';
import Link from 'gatsby-link';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck';

import bgColorStyles from './style/bgColor.module.css';
import generalStyles from './style/general.module.css';

export default function Cta({
  bgColor,
  buttons,
  direction,
  maxWidth,
  size,
  strapline,
  title,
}) {
  const colCount = direction === 'horizontal' ? 6 : 12;
  const textColor = bgColor === 'blue' ? 'white' : 'black';

  const cx = classNames.bind({ ...bgColorStyles, ...generalStyles });

  const ctaClassName = cx('cta', bgColor);
  return (
    <div className={ctaClassName}>
      <Spacing type="padding" sizeM="xl" position="topBottom">
        <PageWrap size="l">
          <Grid columns={12} size="m" alignItems="center">
            <GridItem
              columnSpan={12}
              columnSpanM={colCount}
              alignContent="center"
            >
              <MaxWidth value={maxWidth}>
                <Heading
                  color={textColor}
                  tag="h2"
                  size={size}
                  weight="semibold"
                >
                  {title}
                </Heading>
                {strapline && (
                  <Spacing type="margin" size="m" position="topBottom">
                    <Paragraph color={textColor}>{strapline}</Paragraph>
                  </Spacing>
                )}
              </MaxWidth>
            </GridItem>
            <GridItem
              columnSpan={12}
              columnSpanM={colCount}
              alignContent="center"
            >
              <div className={cx('buttonHolder')}>
                {buttons && (
                  <div className={generalStyles.right}>
                    <div className={generalStyles.buttons}>
                      {buttons.map((button, index) => (
                        <div
                          className={
                            index === buttons.length - 1
                              ? null
                              : generalStyles.margin
                          }
                        >
                          <Link to={button.link} key={button.text}>
                            <Button {...button.styles} key={button.title}>
                              {button.text}
                            </Button>
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </GridItem>
          </Grid>
        </PageWrap>
      </Spacing>
    </div>
  );
}

Cta.propTypes = {
  bgColor: PropTypes.oneOf(Object.keys(bgColorStyles)),
  buttons: PropTypes.array,
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  strapline: PropTypes.string,
  size: PropTypes.string,
  title: propTypeEmptyString,
};

Cta.defaultProps = {
  bgColor: 'white',
  direction: 'horizontal',
  maxWidth: '100%',
  strapline: null,
  size: 'xxxl',
};



// WEBPACK FOOTER //
// ./src/components/modules/Cta/CtaDefault/index.js